import { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import type { FormValues } from "./validation";

export function useSkuRequestFormState() {
  const { watch } = useFormContext();
  const { fields, append, remove } = useFieldArray<FormValues>({
    name: "skus",
  });
  const lastSku = watch(`skus.${fields.length - 1}.sku`);
  const lastQuantity = watch(`skus.${fields.length - 1}.quantity`);

  const makeEmptyRow = () => ({
    sku: null,
    quantity: null,
  });

  useEffect(() => {
    if (fields.length === 0 || lastSku || lastQuantity) {
      append(makeEmptyRow());
    }
  }, [lastSku, lastQuantity, append, fields.length]);

  return { fields, remove };
}
